/*
 * fn: getCardQuery
 *
 * Creates a React Query fn and key to request a single card.
 *
 */
import { type QueryFunction, type QueryKey } from '@tanstack/react-query'

import { type CardIdType } from '@/defs/card'
import { fetchCard } from '@/utils/apiUtil'

type QueryReturnType = {
  queryFn: QueryFunction<Awaited<ReturnType<typeof fetchCard>>, QueryKey>
  queryKey: ['card', CardIdType]
}

export const getCardQuery = (cardId: CardIdType): QueryReturnType => ({
  queryFn: () => fetchCard(cardId),
  queryKey: ['card', cardId],
})
